import { Button } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { useCase } from "src/hooks/useCase";

export function CaseLayoutTitle(props: { caseId: string | number }) {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (pathname.includes("/cases/new")) {
    return (
      <Styles>
        <div className="case-title">
          <span className="title">{t("label.newCase")}</span>
        </div>
      </Styles>
    );
  } else {
    return <CaseTitle caseId={props.caseId} />;
  }
}

function CaseTitle(props: { caseId: string | number }) {
  const { t } = useTranslation();
  const { data: acase } = useCase(props.caseId);

  return render();

  function render() {
    if (!acase) return null;

    return (
      <Styles className="case-title">
        <span className="title">{acase.name}</span>
        <Button component={Link} to="/cases" className="close-btn" size="small" startIcon={<CancelIcon />}>
          {t("label.close")}
        </Button>
      </Styles>
    );
  }
}

const Styles = styled.div`
  margin-left: ${({ theme }) => theme.caseDrawer.width}px;
  align-items: center;
  display: flex;
  height: 100%;

  .title {
    color: #000;
    font-weight: 600;
  }
  .close-btn {
    margin-left: ${({ theme }) => theme.spacing(2)};
    color: #aaa;
  }
`;
